import React, { useState, useEffect, useRef } from "react";
import "./css/Dashboard.css"
import Header from "./Header";
import TabContent from "./TabContent";
import DashboardChatArea from "./DashboardChatArea";
import ChatAreaResizeHandle from "./ChatAreaResizeHandle";
import api from '../api/api'
import DailyReportSettings from "../daily_report/DailyReportSettings";
import WhatIsDailyReport from "../daily_report/WhatIsDailyReport";
import { useDashboardContext } from '../../context/DashboardContext';
import { saveAccessLog } from '../utils/commonUtils'
import { fetchCompanyInfoData } from "../api/api_calls";
import { useNavigate,useLocation } from 'react-router-dom';

export default function Dashboard({ closeClickFunction, chatId=null }) {
    const { state: dashboardState, dispatch: dashboardDispatch } = useDashboardContext();
    const [isChatVisible, setIsChatVisible] = useState(true);
    const [isRegistered, setIsRegistered] = useState(false);
    const [companyInfo, setCompanyInfo] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    const mainRef = useRef(null);
    const modalRef = useRef(null);
    const [secCodeChanged, setSecCodeChanged] = useState(false)
    const [showDailyReportSettings, setShowDailyReportSettings] = useState(false);
    const [showWhatIsDailyReport, setShowWhatIsDailyReport] = useState(false);
    const [modalWidth, setModalWidth] = useState(null);
    const [chatAreaWidth, setChatAreaWidth] = useState(null);

    const toggleChat = () => {
        setIsChatVisible(!isChatVisible);
    };
    
    useEffect(() => {
        const updateChatDefaultSetting = () => {
            if (window.innerWidth < 767) {
                setIsChatVisible(false);
            } else {
                setIsChatVisible(true);
            }
        };

        updateChatDefaultSetting(); // 初回実行

        window.addEventListener('resize', updateChatDefaultSetting);
        return () => {
            window.removeEventListener('resize', updateChatDefaultSetting);
        };
    }, []);

    useEffect(() => {
        setSecCodeChanged(true);
        saveAccessLog('dashboard - ' + dashboardState.secCode);
    }, [dashboardState.secCode]);

    const clickChatAreaCloseButton = () => {
        setIsChatVisible(false)
    }

    const handleResize = (newWidth) => {
        setModalWidth(newWidth);
        setChatAreaWidth(mainRef.current.clientWidth - newWidth); 
    };

    const displayDailyReportSettings = () => {
        setShowDailyReportSettings(true);
    }

    const handleDailyReportSettingsClick = () => {
        setShowDailyReportSettings(false);
    }
    
    const displayWhatIsDailyReport = () => {
        setShowWhatIsDailyReport(true);
    }
    
    const addCompany = async (secCode) => {
        try {
            // APIリクエストで会社を追加
            const response = await api.post(`${process.env.REACT_APP_API_URL}/chat/api/registered-companies/`, {
                company_name: secCode
            });
            setIsRegistered(true);
        } catch (error) {
            console.error(`Error adding company with sec_code ${secCode}:`, error);
        }      
    };

    const removeCompany = async (secCode) => {
        try {
            // APIリクエストでsecCodeを使って会社を削除
            await api.delete(`${process.env.REACT_APP_API_URL}/chat/api/registered-companies/`, {
                data: { sec_code: secCode } // DELETEリクエストのボディにsec_codeを渡す
            });
            setIsRegistered(false);
        } catch (error) {
            console.error(`Error removing company with sec_code ${secCode}:`, error);
        }
    }
    
    useEffect(() => {
        const getComapnyInfo = async () => {
            if (dashboardState.companyInfo) {
                setCompanyInfo(dashboardState.companyInfo);
            } else {
                const response = await fetchCompanyInfoData(dashboardState.secCode, navigate, location)
                dashboardDispatch({ type: 'SET_COMPANY_INFO', payload: response.data })
                setCompanyInfo(response.data);
            }
        }
        if (dashboardState.secCode) {
            getComapnyInfo();
        }
    }, [dashboardState.secCode])
    
    return (
            <div className="dashboardModal" ref={mainRef}>
                <div className={`modal-content ${!isChatVisible ? 'modal-full' : ''}`} ref={modalRef} style={{width: `${modalWidth}px`}}>
                    <div className="inner scrollbar-hide">
                        {closeClickFunction && <span className="dashboard-close-btn close" onClick={closeClickFunction}>&times;</span>}
                        <Header secCode={dashboardState.secCode} displayDailyReportSettings={displayDailyReportSettings} addCompany={addCompany} removeCompany={removeCompany} displayWhatIsDailyReport={displayWhatIsDailyReport} toggleChat={toggleChat} chatDefaultSetting={isChatVisible}  />
                        <TabContent secCode={dashboardState.secCode} secCodeChanged={secCodeChanged} setSecCodeChanged={setSecCodeChanged} companyInfo={companyInfo} />
                    </div>
                </div>
                {isChatVisible && <ChatAreaResizeHandle resizeHandle={handleResize} modalRef={modalRef} />}
                {isChatVisible && <DashboardChatArea chatScreenChatId={chatId} selectedSecCode={dashboardState.secCode} companyName={companyInfo?.company_name} clickCloseButton={clickChatAreaCloseButton} chatAreaWidth={chatAreaWidth} toggleChat={toggleChat} chatDefaultSetting={isChatVisible} />}
                {showDailyReportSettings && <DailyReportSettings handleCloseClick={handleDailyReportSettingsClick}/>}
                {showWhatIsDailyReport && <WhatIsDailyReport setShowWhatIsDailyReport={setShowWhatIsDailyReport} />}
            </div>    
    );
}